import types from 'actions/types';
import { getOptionsGlobal as _getOptionsGlobal } from 'services/global.service';
import { createRequestKey } from 'utils/dedupeRequest';
import { getSupplierOptionsRevision } from 'utils/supplierOptionsRefresh';

const supplierRequestsByDispatch = new WeakMap();
let supplierRequestId = 0;

const showConfirmModal = (message, confirmCallback, labelAccept, labelRefuse, refuseCallback) => {
  return {
    type: types.SHOW_CONFIRM_MODAL,
    payload: { message, labelAccept, labelRefuse, confirmCallback, refuseCallback },
  };
};

const hideConfirmModal = () => ({
  type: types.HIDE_CONFIRM_MODAL,
});

const triggerSidebar = () => ({
  type: types.TRIGGER_SIDEBAR,
});

const showNotify = (payload) => ({
  type: types.SHOW_NOTIFY,
  payload: payload,
});

const hideNotify = () => ({
  type: types.HIDE_NOTIFY,
});

const showNotifyHeader = (payload) => async (dispatch) => {
  dispatch(hideNotify());
  dispatch(showNotify(payload));
};

const getOptionsGlobalRequest = (type, field) => ({
  type,
  field
});

const getOptionsGlobalSuccess = (type, payload, field, params) => ({
  type,
  payload,
  field,
  params,
});

const getOptionsGlobalFailure = (type, payload, field, params) => ({
  type,
  payload,
  field,
  params,
});

const loadSupplierOptions = (dispatch, params, reuseCurrent = false) => {
  const revision = getSupplierOptionsRevision();
  const key = createRequestKey('supplier', params);
  let requests = supplierRequestsByDispatch.get(dispatch);
  if (!requests) {
    requests = new Map();
    supplierRequestsByDispatch.set(dispatch, requests);
  }
  const previous = requests.get(key);
  if (previous?.revision === revision && (previous.pending || (reuseCurrent && previous.succeeded))) {
    return previous.promise;
  }

  const requestId = ++supplierRequestId;
  const current = { revision, pending: true, succeeded: false };
  current.promise = Promise.resolve()
    .then(() => _getOptionsGlobal({ type: 'supplier', ...params }))
    .then(
      (response) => {
        if (revision !== getSupplierOptionsRevision()) {
          return loadSupplierOptions(dispatch, params, true);
        }
        current.succeeded = true;
        dispatch({
          ...getOptionsGlobalSuccess('GET_GLOBAL_OPTIONS_SUPPLIER_SUCCESS', response, 'supplier', params),
          requestId,
        });
        return response;
      },
      (error) => {
        if (revision !== getSupplierOptionsRevision()) {
          return loadSupplierOptions(dispatch, params, true);
        }
        dispatch({
          ...getOptionsGlobalFailure('GET_GLOBAL_OPTIONS_SUPPLIER_FAILURE', error, 'supplier', params),
          requestId,
        });
        throw error;
      },
    )
    .finally(() => { current.pending = false; });
  requests.set(key, current);
  dispatch({ ...getOptionsGlobalRequest('GET_GLOBAL_OPTIONS_SUPPLIER_REQUEST', 'supplier'), requestId });
  return current.promise;
};

const getOptionsGlobal = (field, params) => (dispatch) => {
  if (field === 'supplier') return loadSupplierOptions(dispatch, params);
  const typeActions = `GET_GLOBAL_OPTIONS_${field.toUpperCase()}`;
  return new Promise((resolve, reject) => {
    dispatch(getOptionsGlobalRequest(`${typeActions}_REQUEST`, field));
    _getOptionsGlobal({
      type: field,
      ...params,
    })
      .then((response) => {
        dispatch(getOptionsGlobalSuccess(`${typeActions}_SUCCESS`, response, field, params));
        resolve(response);
      })
      .catch((error) => {
        dispatch(getOptionsGlobalFailure(`${typeActions}_FAILURE`, error, field, params));
        reject(error);
      });
  });
};

export {
  showConfirmModal,
  hideConfirmModal,
  triggerSidebar,
  showNotify,
  hideNotify,
  showNotifyHeader,
  getOptionsGlobal,
};
